import useAuth from "app/hooks/useAuth";
import axios from "axios";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export default function PersistLogin() {

  const [loading, setLoading] = useState(true);
  const { setAuth } = useAuth(); // ✅ available now

  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {

      axios.post(
        "https://backend.dahiyainsurance.com/verify-token.php",
        { Token: token }
      ).then(response => {
        const result = response.data;

        setAuth({
          user: result.Data,
          roles: [5150, 1984, 2001],
          permissions: result?.Permissions || [201],
          accessToken: result.Data.SessionID,
        });
        navigate("/dashboard", { replace: true });
      });
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [navigate]);

  if (loading) return <p>Checking login...</p>;

  return <Outlet />;
}
